export default function SectionContact() {
  return (
    <section id="contact" className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[720px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-400 mb-8">
          有影片推荐、意见反馈或合作咨询？欢迎通过以下方式联系春色影视团队
        </p>

        <div className="bg-background-100/80 rounded-lg border border-background-300/30 p-6 md:p-8">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-12">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/15">
                <i className="ri-mail-line text-primary-400 text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-400">电子邮箱</div>
                <div className="text-sm text-foreground-200 font-medium">contact@chunse.tv</div>
              </div>
            </div>
            <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/15">
                <i className="ri-message-2-line text-accent-400 text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-400">意见反馈</div>
                <div className="text-sm text-foreground-200 font-medium">feedback@chunse.tv</div>
              </div>
            </div>
            <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500/15">
                <i className="ri-team-line text-secondary-400 text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-400">商务合作</div>
                <div className="text-sm text-foreground-200 font-medium">biz@chunse.tv</div>
              </div>
            </div>
          </div>

          <div className="mt-6 pt-6 border-t border-background-300/20">
            <p className="text-xs text-foreground-500">
              我们将在 24 小时内回复您的来信。如需紧急帮助，建议优先查看上方常见问题。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}